module.exports = __webpack_public_path__ + "static/img/logowhite.3bca092.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logowhite.png
// module id = +CtD
// module chunks = 1